import { handleActions } from 'redux-actions';
import actions from '../actions';

const { edit, reset } = actions.receipt;

const defaultState = {};

export default handleActions(
  {
    [edit]: (state, { payload }) => payload,
    [reset]: () => defaultState,
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/reducers/receipt.js